import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BigDecimalService }    from './big-decimal.service';
import { BoxTogglerService }    from './box-toggler.service';
import { CurrencyService }      from './currency.service';
import { DateParserService }    from './date-parser.service';
import { DomainParserService }  from './domain.parser.service';
import { JsonService }          from './json.service';
import { PruneService }         from './prune.service';
import { WindowService }        from './window.service';

@NgModule({
  providers: [
    BigDecimalService,
    BoxTogglerService,
    CurrencyService,
    DateParserService,
    DomainParserService,
    JsonService,
    PruneService,
    WindowService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class ServicesModule {}
